/* No dependencies, customer data, API credentials, or automatic analytics. Apply links in a result are labelled with data-sw-* attributes so the theme's consent-gated tracking script can attribute them. */
(() => {
  if (customElements.get('sw-dealer-quiz')) return;
  class StreetwiseDealerQuiz extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.routes = Array.from(this.querySelectorAll('template[data-route]'));
      if (!this.routes.length) return;
      this.quiz = this.querySelector('[data-quiz]');
      this.result = this.querySelector('[data-result]');
      this.choices = this.querySelector('[data-choices]');
      this.question = this.querySelector('[data-question]');
      this.back = this.querySelector('[data-back]');
      this.querySelector('[data-fallback]').hidden = true;
      this.quiz.hidden = false;
      this.back.addEventListener('click', () => this.showStores(true));
      this.result.addEventListener('click', event => {
        if (event.target.closest('[data-restart]')) this.showStores(true);
      });
      this.showStores(false);
    }
    options(labels, select) {
      this.choices.replaceChildren();
      labels.forEach((label, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'swq__choice';
        const number = document.createElement('span');
        number.className = 'swq__number';
        number.textContent = String(index + 1).padStart(2, '0');
        const text = document.createElement('span');
        text.textContent = label;
        const arrow = document.createElement('span');
        arrow.textContent = '→';
        arrow.setAttribute('aria-hidden', 'true');
        button.append(number, text, arrow);
        button.addEventListener('click', () => select(label));
        this.choices.append(button);
      });
    }
    step(number, title, focus) {
      this.querySelector('[data-progress]').textContent = `Question ${number} of 2`;
      this.querySelector('[data-bar]').style.width = `${number * 50}%`;
      this.question.textContent = title;
      this.back.hidden = number === 1;
      if (focus) this.question.focus();
    }
    showStores(focus) {
      this.result.hidden = true;
      this.result.replaceChildren();
      this.quiz.hidden = false;
      this.options([...new Set(this.routes.map(r => r.dataset.store))], label => this.showPriorities(label));
      this.step(1, 'What type of business do you run?', focus);
    }
    showPriorities(store) {
      const routes = this.routes.filter(r => r.dataset.store === store);
      this.options([...new Set(routes.map(r => r.dataset.priority))], priority => {
        const route = routes.find(r => r.dataset.priority === priority);
        this.result.replaceChildren(route.content.cloneNode(true));
        this.result.querySelectorAll('[data-apply]').forEach(link => {
          link.dataset.swSource = 'quiz';
          link.dataset.swQuizStore = store;
          link.dataset.swQuizPriority = priority;
        });
        this.result.querySelectorAll('[data-sales-expiry]').forEach(badge => {
          if (Number(badge.dataset.salesExpiry) * 1000 <= Date.now()) badge.remove();
        });
        this.quiz.hidden = true;
        this.result.hidden = false;
        this.result.querySelector('h3').focus();
      });
      this.step(2, 'What would you like to focus on?', true);
    }
  }
  customElements.define('sw-dealer-quiz', StreetwiseDealerQuiz);
})();
